import { useTranslation } from 'react-i18next';
import { SplitButton } from '@shared/ui/buttons';
import { SelectedCardsMenu } from '@widgets/cards/menu';

export default function TableSelectedButton({ selected }) {
  const { t } = useTranslation();

  return (
    <div className="d-flex">
      <SplitButton
        text={
          <>
            <div className="custom-badge">{selected.length}</div>
            {t('selected')}
          </>
        }
        menuComponent={SelectedCardsMenu}
        menuProps={{ data: selected }}
      />
    </div>
  );
}
